import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ImageCard from '../../image-card'
import { IconLogo } from '../../icons'

import './index.styl'

const BrandConcept = ({ pageData }) => {
  const {
    first_block,
    feature1_title,
    feature1_content,
    feature2_title,
    feature2_content,
    feature3_title,
    feature3_content,
    feature4_title,
    feature4_content,
    second_block,
    image1,
    image2,
    certification1,
    certification2,
    certification3,
    certification4,
    customer_review1,
    customer_review2,
  } = pageData

  const { t } =  useTranslation()

  return (
    <div className="brand-concept">
      <div className="brand-concept__introduction">
        <div className="brand-concept__introduction__content">
          <IconLogo className="brand-concept__introduction__logo" />
          <div className="brand-concept__paragraph">
            <span className="brand-concept__text-b">
              {first_block.replace(/\s.*/, '')}
            </span>
            {first_block.match(/\s.*/)[0]}
          </div>
        </div>
        <ImageCard
          className="brand-concept__introduction__img"
          imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${image1}`}
        />
      </div>
      <div className="brand-concept__content-wrap brand-concept__content-wrap__grey-bg">
        <ImageCard
          className="brand-concept__content-img"
          imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${image2}`}
        />
        <div className="brand-concept__content">
          <h2 className="brand-concept__title">{feature1_title}</h2>
          <div className="brand-concept__paragraph">{feature1_content}</div>
          <h2 className="brand-concept__title">{feature2_title}</h2>
          <div className="brand-concept__paragraph">{feature2_content}</div>
          <h2 className="brand-concept__title">{feature3_title}</h2>
          <div className="brand-concept__paragraph">{feature3_content}</div>
          <h2 className="brand-concept__title">{feature4_title}</h2>
          <div className="brand-concept__paragraph">{feature4_content}</div>
        </div>
      </div>
      {
        (second_block || certification1 || certification2 || certification3 || certification4) && (
          <div className="brand-concept__content-wrap brand-concept__content-wrap__dark-bg">
            {
              second_block && (
                <>
                  <IconLogo className="brand-concept__content-logo" mode="column" />
                  <div className="brand-concept__paragraph">{second_block}</div>
                </>
              )
            }
            {
              (certification1 || certification2 || certification3 || certification4) && (
                <div className="brand-concept__certification-wrap">
                  {
                    certification1 && (
                      <div className="brand-concept__certification-img-wrap">
                        <ImageCard
                          className="brand-concept__certification-img"
                          imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${certification1}`}
                        />
                      </div>
                    )
                  }
                  {
                    certification2 && (
                      <div className="brand-concept__certification-img-wrap">
                        <ImageCard
                          className="brand-concept__certification-img"
                          imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${certification2}`}
                        />
                      </div>
                    )
                  }
                  {
                    certification3 && (
                      <div className="brand-concept__certification-img-wrap">
                        <ImageCard
                          className="brand-concept__certification-img"
                          imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${certification3}`}
                        />
                      </div>
                    )
                  }
                  {
                    certification4 && (
                      <div className="brand-concept__certification-img-wrap">
                        <ImageCard
                          className="brand-concept__certification-img"
                          imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${certification4}`}
                        />
                      </div>
                    )
                  }
                </div>
              )
            }
            {
              customer_review1 && (
                  <ImageCard
                    className="brand-concept__customer-review-img"
                    imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${customer_review1}`}
                  />
              )
            }
            {
              customer_review2 && (
                  <ImageCard
                    className="brand-concept__customer-review-img"
                    imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${customer_review2}`}
                  />
              )
            }
          </div>
        )
      }
    </div>
  )
}

BrandConcept.propTypes = {}

export default BrandConcept
